import { useAppSelector } from "../../../../../../store/reduxHooks";
import { SELECT_REQUEST_BANK_ID } from "../../../../../../store/selectors/requestAppSelector";
import { UI_ITOModuleSubTitle } from "../../../../../../UI_ITO/indexUI";
import { DocListCommissionStatusHideSignForDownload } from "../../../../DocListForDownload/DocListComissionStatuses/HideSignInfo/DocListCommissionStatusesHideInfo";
import classes from "../../style/connectedBanksStatusBlocks.module.css";

export const StatusesWithCommissionHideSignInfo = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);
  const info = {
    bank_commission: data.overstatement
      ? +data.overstatement + +data.base_commission
      : data.base_commission,
  };

  return (
    <div className={classes.infoContainer}>
      <h3 className={classes.infoHeader}>Информация</h3>

      <div className={classes.info}>
        <div className={classes.info_row_key}>Комиссия банка</div>

        <div className={classes.info_row_value}>{info.bank_commission} ₽</div>
      </div>

      <UI_ITOModuleSubTitle
        className={classes.sectionDocHeader}
        title={"Документы от банка"}
      />

      <DocListCommissionStatusHideSignForDownload />
    </div>
  );
};
